export { default } from './LoadingTile';
